import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { actions } from './dashboardReducer';
import DashboardComponent from './DashboardComponent';

const DashboardContainer = ({
  timeseries,
  recentScans,
  period,
  loading,
  timeseriesLoading,
  fetchTimeseries,
  fetchRecentScans,
  fetchBreakdowns,
  setPeriod,
}) => {
  useEffect(() => {
    fetchTimeseries(period);
  }, [fetchTimeseries, period]);

  useEffect(() => {
    fetchBreakdowns(period);
  }, [fetchBreakdowns, period]);

  useEffect(() => {
    fetchRecentScans();
  }, [fetchRecentScans]);

  const handlePeriodChange = useCallback(
    (days) => {
      setPeriod(days);
    },
    [setPeriod]
  );

  return (
    <DashboardComponent
      timeseries={timeseries}
      recentScans={recentScans}
      period={period}
      loading={loading}
      timeseriesLoading={timeseriesLoading}
      onPeriodChange={handlePeriodChange}
    />
  );
};

const mapStateToProps = (state) => ({
  timeseries: state.guardian.dashboard.timeseries,
  recentScans: state.guardian.dashboard.recentScans,
  period: state.guardian.dashboard.period,
  loading: state.guardian.dashboard.loading,
  timeseriesLoading: state.guardian.dashboard.timeseriesLoading,
});

const mapDispatchToProps = {
  fetchTimeseries: actions.fetchTimeseries,
  fetchRecentScans: actions.fetchRecentScans,
  fetchBreakdowns: actions.fetchBreakdowns,
  setPeriod: actions.setPeriod,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);
